import { useSpring, animated as a } from "@react-spring/web";
import { Html } from "@react-three/drei";
import { useRive } from "@rive-app/react-canvas";
import { useEffect, useMemo } from "react";
import { findChildStartsWithKey } from "../../../../utils/FindObjects";
import { MarkerLabels } from "../../../ui/MarkerLabel";
import InductiveTransmissionAnimation from "../../effects/InductiveTransmissionAnimation";

const DynamicCharge = ({ object3d, ...props }) => {
  const batteryTarget = useMemo(() => {
    return findChildStartsWithKey("rive_position_p_dynamic", object3d);
  }, []);
  const flashTarget = useMemo(() => {
    return findChildStartsWithKey("rive_position_p_dynamic2", object3d);
  }, []);

  const marker = useMemo(() => {
    return findChildStartsWithKey("markers_p_dynamiccharge", object3d);
  }, []);

  const induction = useMemo(() => {
    return findChildStartsWithKey("induction", object3d);
  }, []);

  return (
    <>
      <FlashAnimation batteryStyle riveSrc="./assets/rive/enrx_battery.riv" position={batteryTarget.position} />
      <FlashAnimation riveSrc="./assets/rive/enrx_flash.riv" position={flashTarget.position} />
      <InductiveTransmissionAnimation position={induction.position} scale={0.12} />
      <MarkerLabels node={marker} />
    </>
  );
};

const FlashAnimation = ({ riveSrc, batteryStyle, ...props }) => {
  const revealSpring = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 2000 },
  });

  const { rive, RiveComponent } = useRive({
    src: riveSrc,
    autoplay: false,
  });

  useEffect(() => {
    rive && rive.play();
  }, [rive]);

  return (
    <group {...props}>
      {/* <mesh>
        <sphereGeometry args={[0.1]} />
      </mesh> */}
      <Html
        style={{
          pointerEvents: "none",
        }}
      >
        <a.div
          style={{
            width: batteryStyle ? "8vw" : "15vw",
            height: "15vw",
            transform: "translate(-50%,-50%)",

            opacity: revealSpring.opacity,
          }}
        >
          <RiveComponent />
        </a.div>
      </Html>
    </group>
  );
};

export default DynamicCharge;
